<template>
    <div class="footer-wrapper">
        <div class="copyright-line1"></div>
        <div class="container">
            <!-- 关于 -->
            <!-- <div  class="footer-column col-md-2 col-sm-4 col-xs-6">
  <h3 class="column-title">关于</h3>
  <ul>
    <li ><a href="" target="_blank">关于我们</a></li>
    <li ><a href="" target="_blank">服务协议</a></li>
    <li ><a href="" target="_blank">合作协议</a></li>
  </ul>
</div> -->
            <!-- 产品 -->
            <!-- <div  class="footer-column col-md-2 col-sm-4 col-xs-6">
  <h3 class="column-title">产品</h3>
  <ul>
    <li ><a href="" target="_blank">功能介绍</a></li>
    <li ><a href="" target="_blank">价格</a></li>
  </ul>
</div> -->
            <!-- 示例 -->
            <!-- <div  class="footer-column col-md-2 col-sm-4 col-xs-6">
      <h3 class="column-title">示例</h3>
      <ul>
        <router-link tag="li" to="/sample/scenarios" >解决方案</router-link>
        <router-link tag="li" to="/sample/cases" >项目案例</router-link>
        <router-link tag="li" to="/sample/model" ><a href="">模型文件</a></router-link>
        <router-link tag="li" to="/live-demo" ><a href="">代码示例</a></router-link>
      </ul>
</div> -->
            <div class="footer-column col-md-2 col-sm-4 col-xs-6">
                <ul>
                    <li class="lipointer" @click="pathTo('router', '/devcenter')">开发者中心</li>
                    <li
                        class="lipointer"
                        @click="
                            pathTo(
                                'mkdocs',
                                '/devcenter/help/development-guide/docs/upload-model/docs/development-guide/',
                            )
                        "
                    >
                        开发指南
                    </li>
                    <li
                        class="lipointer"
                        @click="pathTo('mkdocs', '/devcenter/help/js-api/docs/demo-api/docs/demo-api/')"
                    >
                        API文档
                    </li>
                    <li class="lipointer" @click="toPlayground()">示例展示</li>
                    <li class="lipointer" @click="pathTo('swaggerdist', '/devcenter/help/server-api/docs/oauth2.0/')">
                        Oauth2.0服务
                    </li>
                    <li class="lipointer" @click="pathTo('swaggerdist', '/devcenter/help/server-api/docs/Storage/')">
                        对象存储服务
                    </li>
                    <li
                        class="lipointer"
                        @click="pathTo('swaggerdist', '/devcenter/help/server-api/docs/Translation/')"
                    >
                        数据转换服务
                    </li>
                    <!-- <li ><a :href=getDevelopmentGuideUrl() target="_blank">开发指南</a></li>
<li ><a :href=getServerApiUrl() target="_blank">服务端API</a></li>
<li ><a :href=getJsApiUrl() target="_blank">JavaScript API</a></li> -->
                </ul>
            </div>
            <!-- <div class="footer-column col-md-2 col-sm-4 col-xs-12 col-xs-6">
  <h3 class="column-title">友情链接</h3>
  <ul> -->
            <!--<li><a href="http://www.aecworks.cn/" target="_blank">AECWorks</a></li>-->
            <!-- <li><a href="http://www.cabr.com.cn/" target="_blank">中国建筑科学研究院</a></li>
    <li><a href="https://bimbox.pkpm.cn" target="_blank">PKPM BIMBox</a></li>
  </ul>
</div> -->
            <div class="footer-column col-md-4 col-sm-4 col-xs-8">
                <h3 class="column-title">联系我们</h3>
                <ul>
                    <li class="weli">Email：cloud@pkpm.com.cn</li>
                    <li class="weli">电话：189-1614-5929（微信同号） 吴经理</li>
                    <li class="weli">邮编：100013</li>
                    <li class="weli">地址：北京市北三环东路30号C栋15层</li>
                    <li class="weli" style="margin-left: 40px;">上海市黄浦区打浦路88号海丽大厦19层</li>
                    <!-- <li class="social-account">
  <a href="" class="wx-link">
    <i class="fa fa-weixin"></i>
    <img src="../../static/img/aecworks-ewm.png" alt="">
  </a>
</li>
<li class="social-account">
  <a href="" class="qq-link">
    <i class="fa fa-qq"></i>
    <img src="../../static/img/obv-developer.jpg" alt="">
  </a>
</li> -->
                    <!--<li class="social-account github">
  <a href="" class="github-link">
    <i class="iconfont icon-GitHub"></i>
  </a>
</li>-->
                </ul>
            </div>
        </div>
        <div class="copyright-line2"></div>
        <div class="copyright">
            Copyright &copy; 2016 北京构力科技有限公司 版权所有
            <a href="http://www.beian.miit.gov.cn/" target="_blank">
                京ICP备17027954号-1
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cfooter',
    methods: {
        getDevelopmentGuideUrl() {
            return `${window.location.origin}/help/development-guide/docs/development-guide/index.html`;
        },
        getServerApiUrl() {
            return `${window.location.origin}/help/server-api/docs/server-api/index.html`;
        },
        getJsApiUrl() {
            return `${window.location.origin}/help/js-api/docs/js-api/index.html`;
        },
        pathTo(type, url) {
            if (type !== 'router') {
                window.open(`${window.location.origin}${url}`, '_blank');
            } else {
                this.$router.push(url);
            }
        },
        // 底部导航示例展示跳转
        toPlayground() {
            window.open('/playground/lod/');
        },
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.footer-wrapper
  z-index -1
  position absolute
  // margin-top: 10%;
  width 100%
  height 700px
  bg_img('../../static/dataMock/homePage/HPbanner3.png')
  dom_center()
  flex-direction column

  .copyright-line1
    margin-top 15%
    background-color $background-white
    opacity 0.5
    width 100%
    height 1px

  .container
    top 0
    display flex
    align-items flex-start
    justify-content center

    .footer-column
      font-size $font-size-text
      font-weight 700
      color $font-white
      padding-top 20px

      .column-title
        padding-bottom 12px

      .lipointer
        cursor pointer
        padding-bottom 24px
        font-size $font-size-text
        color $font-white
        opacity 0.9

        &:hover
          color #888f9a

      .weli
        padding 12px 0
        font-size $font-size-text
        color $font-white
        opacity 0.9

      .social-account
        float left
        margin-right 25px

        .wx-link, .qq-link
          position relative

          &:hover
            i
              color #0e73af

            img
              transform scale(1)
              opacity 1

          img
            position absolute
            z-index 9
            top -135px
            right -28px
            width 7.5rem
            max-width none
            height 7.5rem
            transform scale(0)
            transform-origin bottom center
            opacity 0
            border 0.3125rem solid #0e73af
            border-radius 0.25rem
            -webkit-transition all 0.4s ease-in-out
            -o-transition all 0.4s ease-in-out
            transition all 0.4s ease-in-out

  .copyright-line2
    background-color $background-white
    opacity 0.5
    width 73%
    height 1px

  .copyright
    position absolute
    bottom 0px
    color $font-white
    text-align center
    margin-bottom 1%

    a
      text-decoration none
      color white
</style>



// WEBPACK FOOTER //
// src/components/cfooter.vue